import React, { useMemo } from 'react';
import { Column, Row, Section } from '@ydistri/ds';
import PickingResultsNavigation from './PickingResultsNavigation';
import { PickingResultsPart } from '../pickingResultsLib';
import PickingPerformance from '../parts/performance/PickingPerformance';
import PickingIssues from '../parts/issues/PickingIssues';
import { usePickingResultsPart } from '../hooks/usePickingResultsPart';
import StoreEvaluationsTable from '../../Evaluation/components/StoreEvaluationsTable/StoreEvaluationsTable';
import CalculationEvaluationSummary from '../../Evaluation/components/summary/CalculationEvaluationSummary';
import CalculationOverallPickingStatistics from '../parts/performance/stats/CalculationOverallPickingPerformanceStatistics';

const sectionTitles: Record<PickingResultsPart, string> = {
  [PickingResultsPart.EXECUTION]: 'Store picking execution',
  [PickingResultsPart.PERFORMANCE]: 'Store picking performance',
  [PickingResultsPart.ISSUES]: 'Store picking issues',
};

/**
 * Content of the section with header, table and button to export the table.
 */
const SectionStorePickingResults: React.FC = () => {
  const currentPart = usePickingResultsPart();

  const headerComponent = sectionTitles[currentPart];

  const bodyComponent = useMemo(() => {
    switch (currentPart) {
      case PickingResultsPart.EXECUTION:
        return (
          <Column $flexGrow={1} $gap="0.5rem" data-type="store-evaluations-section-content">
            <CalculationEvaluationSummary />
            <StoreEvaluationsTable />
          </Column>
        );
      case PickingResultsPart.PERFORMANCE:
        return (
          <>
            <Row $padding={2}>
              <CalculationOverallPickingStatistics />
            </Row>
            <PickingPerformance />
          </>
        );
      case PickingResultsPart.ISSUES:
        return <PickingIssues />;
      default:
        return null;
    }
  }, [currentPart]);

  return (
    <Section
      header={headerComponent}
      headerActions={<PickingResultsNavigation />}
      headerActionsIncludeMarginBottom={false}
    >
      {bodyComponent}
    </Section>
  );
};

export default SectionStorePickingResults;
